(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["thco-hype-pass"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
  if (!root || root.dataset.ready === 'true') return;
  root.dataset.ready = 'true';

  const apiBase = root.dataset.apiBase.replace(/\/$/, '');
  const storageKey = 'thco_hype_session_6066_v2';
  const $ = (selector) => root.querySelector(selector);
  const $$ = (selector) => Array.from(root.querySelectorAll(selector));
  const login = $('[data-hp-login]');
  const app = $('[data-hp-app]');
  const loading = $('[data-hp-loading]');
  const phoneStep = $('[data-hp-phone-step]');
  const otpStep = $('[data-hp-otp-step]');
  const registerStep = $('[data-hp-register-step]');
  const errorBox = $('[data-hp-error]');
  const live = $('[data-hp-live]');
  let challengeId = '';
  let verifiedPhone = '';
  let resendTimer = null;
  let allTransactions = [];
  let allVouchers = [];
  const messages = Object.fromEntries($$('[data-hp-i18n] [data-key]').map((item) => [item.dataset.key, item.textContent.trim()]));
  const t = (key) => messages[key] || key;
  const interpolate = (key, values) => Object.entries(values).reduce((copy, entry) => copy.replaceAll(`{${entry[0]}}`, entry[1]), t(key));

  const setBusy = (button, busy, busyText) => {
    if (!button) return;
    if (busy) {
      button.dataset.label = button.textContent;
      button.textContent = busyText;
      button.disabled = true;
    } else {
      button.textContent = button.dataset.label || button.textContent;
      button.disabled = false;
    }
  };

  const showError = (message) => {
    errorBox.textContent = message;
    errorBox.hidden = !message;
    live.textContent = message;
  };

  const request = async (path, options = {}) => {
    const response = await fetch(apiBase + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
      body: options.body ? JSON.stringify(options.body) : undefined,
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) {
      const error = new Error(data.error || 'request_failed');
      error.status = response.status;
      throw error;
    }
    return data;
  };

  const formatPhone = () => {
    const country = $('[data-hp-country]').value;
    let digits = $('[data-hp-phone]').value.replace(/\D/g, '');
    if (digits.startsWith(country)) return '+' + digits;
    digits = digits.replace(/^0+/, '');
    return '+' + country + digits;
  };

  const readableError = (code) => {
    return messages[code] || t('request_failed');
  };

  const checkHealth = async () => {
    const button = $('[data-hp-request]');
    try {
      const response = await fetch(apiBase + '/hype-auth-health', { method: 'GET', cache: 'no-store' });
      const health = await response.json();
      root.dataset.whatsappConfigured = String(Boolean(health.whatsapp_configured));
      root.dataset.shopifyConfigured = String(Boolean(health.shopify_configured));
      root.dataset.shopifyWebhookSecretConfigured = String(Boolean(health.shopify_webhook_secret_configured));
      if (!health.whatsapp_configured || !health.otp_sender_6066_configured) {
        button.disabled = true;
        showError(t('whatsapp_not_configured'));
      }
    } catch {
      root.dataset.whatsappConfigured = 'unknown';
    }
  };

  const startResend = (seconds = 60) => {
    const button = $('[data-hp-resend]');
    clearInterval(resendTimer);
    let left = seconds;
    button.disabled = true;
    button.textContent = interpolate('resend_in', { count: String(left) });
    resendTimer = setInterval(() => {
      left -= 1;
      button.textContent = left > 0 ? interpolate('resend_in', { count: String(left) }) : t('resend_code');
      if (left <= 0) {
        clearInterval(resendTimer);
        button.disabled = false;
      }
    }, 1000);
  };

  const sendOtp = async () => {
    showError('');
    if (!$('[data-hp-consent]').checked) {
      showError(t('consent_required'));
      return;
    }
    const phone = formatPhone();
    if (!/^\+[1-9]\d{7,14}$/.test(phone)) {
      showError(t('invalid_phone'));
      return;
    }
    const button = $('[data-hp-request]');
    if (button.disabled) return;
    setBusy(button, true, t('sending_code'));
    try {
      const data = await request('/hype-auth-request-otp', { body: { phone, purpose: 'login' } });
      challengeId = data.challenge_id;
      verifiedPhone = phone;
      $('[data-hp-phone-preview]').textContent = phone;
      phoneStep.hidden = true;
      otpStep.hidden = false;
      $('[data-hp-otp]').focus();
      startResend(data.resend_in || 60);
      live.textContent = t('code_sent');
    } catch (error) {
      showError(readableError(error.message));
    } finally {
      setBusy(button, false);
    }
  };

  const verifyOtp = async () => {
    showError('');
    const otp = $('[data-hp-otp]').value.replace(/\D/g, '').slice(0, 6);
    if (otp.length !== 6) {
      showError(t('otp_required'));
      return;
    }
    const button = $('[data-hp-verify]');
    if (button.disabled) return;
    setBusy(button, true, t('verifying'));
    try {
      const data = await request('/hype-auth-verify-otp', {
        body: { phone: verifiedPhone, otp, challenge_id: challengeId },
      });
      if (data.needs_registration) {
        otpStep.hidden = true;
        registerStep.hidden = false;
        $('[data-hp-register-name]').focus();
        return;
      }
      if (!/^[a-f0-9]{64}$/.test(String(data.session_token || ''))) throw new Error('verification_failed');
      localStorage.setItem(storageKey, data.session_token);
      await loadAccount(data.session_token);
    } catch (error) {
      showError(readableError(error.message));
    } finally {
      setBusy(button, false);
    }
  };

  const registerMember = async () => {
    const button = $('[data-hp-register]');
    if (button.disabled) return;
    const fullName = $('[data-hp-register-name]').value.trim();
    const email = $('[data-hp-register-email]').value.trim().toLowerCase();
    if (!fullName) return showError(t('name_required'));
    if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return showError(t('invalid_email'));
    setBusy(button, true, t('creating'));
    showError('');
    try {
      const data = await request('/hype-auth-register', {body:{challenge_id:challengeId,phone:verifiedPhone,full_name:fullName,email}});
      if (!/^[a-f0-9]{64}$/.test(String(data.session_token || ''))) throw new Error('registration_failed');
      localStorage.setItem(storageKey, data.session_token);
      registerStep.hidden = true;
      await loadAccount(data.session_token);
    } catch (error) {
      showError(messages[error.message] || t('registration_failed'));
    } finally {
      setBusy(button, false);
    }
  };

  const locale = document.documentElement.lang || 'en-MY';
  const number = (value) => new Intl.NumberFormat(locale).format(Number(value || 0));
  const date = (value, long = false) => {
    if (!value) return '—';
    return new Intl.DateTimeFormat(locale, long
      ? { day: 'numeric', month: 'long', year: 'numeric' }
      : { day: 'numeric', month: 'short', year: 'numeric' }
    ).format(new Date(value));
  };
  const escapeHtml = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;'
  })[char]);

  const transactionHtml = (row) => {
    const used = row.type === 'debit' || Number(row.signed_points) < 0;
    const signed = used ? -Math.abs(Number(row.points || 0)) : Math.abs(Number(row.points || 0));
    const title = row.description || (used ? t('credits_used') : t('credits_earned'));
    return `<article class="hp-transaction ${used ? 'is-used' : ''}">
      <span class="hp-transaction__mark" aria-hidden="true">${used ? '−' : '+'}</span>
      <div class="hp-transaction__copy"><strong>${escapeHtml(title)}</strong><span>${date(row.created_at)}</span></div>
      <span class="hp-transaction__points">${signed > 0 ? '+' : ''}${number(signed)}</span>
    </article>`;
  };

  const renderTransactions = (rows, target, emptyCopy) => {
    target.innerHTML = rows.length
      ? rows.map(transactionHtml).join('')
      : `<div class="hp-empty"><strong>${escapeHtml(t('no_activity_title'))}</strong><p>${escapeHtml(emptyCopy)}</p></div>`;
  };

  const plainText = (value) => String(value ?? '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();

  const voucherValue = (template = {}) => {
    if (template.discount_kind === 'amount' && Number(template.amount_off) > 0) {
      return `RM${number(template.amount_off)} OFF`;
    }
    if (template.discount_kind === 'percentage' && Number(template.percent_off) > 0) {
      return `${number(template.percent_off)}% OFF`;
    }
    return plainText(template.title) || t('voucher_available');
  };

  const voucherHtml = (voucher) => {
    const template = voucher.template || {};
    const isExpired = voucher.status === 'expired' || (voucher.expires_at && new Date(voucher.expires_at).getTime() <= Date.now());
    const isUsed = voucher.status === 'used';
    const syncStatus = voucher.shopify_sync_status || 'pending';
    const status = isUsed ? 'used' : (isExpired ? 'expired' : 'available');
    const statusCopy = status === 'used' ? t('voucher_used') : (status === 'expired' ? t('voucher_expired') : t('voucher_available'));
    const canUse = status === 'available';
    const provisioning = syncStatus === 'provisioning';
    const buttonCopy = syncStatus === 'active' ? t('use_at_checkout') : (provisioning ? t('activating_voucher') : t('activate_and_use'));
    const minSpend = Number(template.min_spend || 0) > 0
      ? interpolate('min_spend', { amount: number(template.min_spend) })
      : '';
    const validity = interpolate('valid_until', { date: date(voucher.expires_at) });
    const details = [minSpend, validity].filter(Boolean).join(' · ');

    return `<article class="hp-voucher is-${status}" data-voucher-id="${escapeHtml(voucher.id)}">
      <div class="hp-voucher__top"><span class="hp-voucher__brand">THCO. HYPE PASS</span><span class="hp-voucher__status">${escapeHtml(statusCopy)}</span></div>
      <div class="hp-voucher__body"><h2>${escapeHtml(voucherValue(template))}</h2><p>${escapeHtml(plainText(template.title))}</p></div>
      <div class="hp-voucher__footer">
        <div><span class="hp-voucher__meta">${escapeHtml(details)}</span><strong class="hp-voucher__code">${escapeHtml(voucher.code)}</strong></div>
        ${canUse ? `<button class="hp-voucher__action" type="button" data-hp-activate-voucher="${escapeHtml(voucher.id)}" ${provisioning ? 'disabled' : ''}>${escapeHtml(buttonCopy)}</button>` : ''}
      </div>
    </article>`;
  };

  const renderVouchers = () => {
    const target = $('[data-hp-vouchers]');
    target.innerHTML = allVouchers.length
      ? allVouchers.map(voucherHtml).join('')
      : `<div class="hp-empty"><strong>${escapeHtml(t('voucher_empty'))}</strong></div>`;
  };

  const loadVouchers = async (token) => {
    try {
      const data = await request('/hype-auth-vouchers', { headers: { Authorization: `Bearer ${token}` } });
      if (localStorage.getItem(storageKey) !== token) return;
      allVouchers = Array.isArray(data.vouchers) ? data.vouchers : [];
      renderVouchers();
    } catch {
      if (localStorage.getItem(storageKey) !== token) return;
      allVouchers = [];
      $('[data-hp-vouchers]').innerHTML = `<div class="hp-empty"><strong>${escapeHtml(t('voucher_load_failed'))}</strong></div>`;
    }
  };

  const activateVoucher = async (button) => {
    const token = localStorage.getItem(storageKey);
    if (!token) return loadAccount('');
    const voucherId = button.dataset.hpActivateVoucher;
    setBusy(button, true, t('activating_voucher'));
    try {
      let result = null;
      for (let attempt = 0; attempt < 7; attempt += 1) {
        result = await request('/hype-auth-redeem-voucher', {
          headers: { Authorization: `Bearer ${token}` },
          body: { user_voucher_id: voucherId },
        });
        if (result.status !== 'provisioning') break;
        await new Promise((resolve) => setTimeout(resolve, 800));
      }
      if (result?.status === 'active' && result.checkout_url) {
        window.location.assign(result.checkout_url);
        return;
      }
      if (result?.status === 'used' || result?.status === 'expired') await loadVouchers(token);
      else throw new Error('voucher_activation_failed');
    } catch (error) {
      showError(readableError(error.message));
      setBusy(button, false);
      await loadVouchers(token);
    }
  };

  const fill = (selector, value) => {
    const el = $(selector);
    if (el) el.textContent = value || '—';
  };

  const renderAccount = (data) => {
    const profile = data.profile || {};
    const wallet = data.wallet || {};
    allTransactions = Array.isArray(data.transactions) ? data.transactions : [];
    const name = profile.full_name || t('hype_member');
    const memberId = String(profile.member_id || '');
    const memberShort = memberId ? memberId.replace(/-/g, '').slice(-8).toUpperCase() : '—';
    const initials = name.split(/\s+/).filter(Boolean).slice(0, 2).map((part) => part[0]).join('').toUpperCase() || 'HP';
    const firstName = name.split(/\s+/).filter(Boolean)[0] || t('hype_member');
    const contact = [profile.email, profile.phone].filter(Boolean).join(' · ') || t('member_fallback');

    fill('[data-hp-greeting]', interpolate('welcome_name', { name: firstName }));
    fill('[data-hp-first-name]', firstName);
    fill('[data-hp-welcome-initials]', initials);
    fill('[data-hp-member-short]', memberShort);
    fill('[data-hp-member-id]', memberId || '—');
    fill('[data-hp-balance]', number(wallet.balance_points));
    fill('[data-hp-lifetime]', number(wallet.lifetime_points));
    fill('[data-hp-member-since]', date(profile.member_since));
    fill('[data-hp-name]', name);
    fill('[data-hp-contact]', contact);
    fill('[data-hp-initials]', initials);
    fill('[data-hp-profile-name]', name);
    fill('[data-hp-profile-fullname]', name);
    fill('[data-hp-profile-phone]', profile.phone || t('not_provided'));
    fill('[data-hp-profile-email]', profile.email || t('not_provided'));
    fill('[data-hp-profile-since]', date(profile.member_since, true));
    renderTransactions(allTransactions.slice(0, 5), $('[data-hp-recent]'), t('recent_empty'));
    renderTransactions(allTransactions, $('[data-hp-transactions]'), t('all_empty'));
  };

function numericQr(value) {
  const text = String(value);
  if (!/^\d{1,41}$/.test(text)) throw new Error('invalid_member_id');
  const bits = [];
  const append = (value, width) => {
    for (let i = width - 1; i >= 0; i -= 1) bits.push((value >>> i) & 1);
  };
  append(1, 4);
  append(text.length, 10);
  for (let i = 0; i < text.length; i += 3) {
    const group = text.slice(i, i + 3);
    append(Number(group), group.length === 3 ? 10 : group.length === 2 ? 7 : 4);
  }
  append(0, Math.min(4, 152 - bits.length));
  while (bits.length % 8) bits.push(0);
  const data = [];
  for (let i = 0; i < bits.length; i += 8) {
    data.push(bits.slice(i, i + 8).reduce((byte, bit) => (byte << 1) | bit, 0));
  }
  for (let pad = 0; data.length < 19; pad += 1) data.push(pad % 2 ? 0x11 : 0xec);
  const exp = new Array(512);
  const log = new Array(256).fill(0);
  let field = 1;
  for (let i = 0; i < 255; i += 1) {
    exp[i] = field;
    log[field] = i;
    field <<= 1;
    if (field & 0x100) field ^= 0x11d;
  }
  for (let i = 255; i < 512; i += 1) exp[i] = exp[i - 255];
  const multiply = (a, b) => a && b ? exp[log[a] + log[b]] : 0;
  let generator = [1];
  for (let i = 0; i < 7; i += 1) {
    const next = new Array(generator.length + 1).fill(0);
    generator.forEach((coefficient, index) => {
      next[index] ^= coefficient;
      next[index + 1] ^= multiply(coefficient, exp[i]);
    });
    generator = next;
  }
  const remainder = data.concat(new Array(7).fill(0));
  for (let i = 0; i < data.length; i += 1) {
    const coefficient = remainder[i];
    if (coefficient) generator.forEach((value, j) => { remainder[i + j] ^= multiply(value, coefficient); });
  }
  const words = data.concat(remainder.slice(-7));
  const matrix = Array.from({ length: 21 }, () => new Array(21).fill(null));
  const set = (row, column, value) => { matrix[row][column] = Boolean(value); };
  const finder = (top, left) => {
    for (let row = -1; row <= 7; row += 1) {
      for (let column = -1; column <= 7; column += 1) {
        const y = top + row;
        const x = left + column;
        if (y < 0 || y >= 21 || x < 0 || x >= 21) continue;
        set(y, x, row >= 0 && row <= 6 && column >= 0 && column <= 6 &&
          (row === 0 || row === 6 || column === 0 || column === 6 || (row >= 2 && row <= 4 && column >= 2 && column <= 4)));
      }
    }
  };
  finder(0, 0);
  finder(0, 14);
  finder(14, 0);
  for (let i = 8; i < 13; i += 1) {
    set(6, i, i % 2 === 0);
    set(i, 6, i % 2 === 0);
  }
  const format = 0x77c4;
  for (let i = 0; i < 15; i += 1) {
    const bit = (format >>> i) & 1;
    set(i < 6 ? i : i < 8 ? i + 1 : 21 - 15 + i, 8, bit);
    set(8, i < 8 ? 21 - i - 1 : i < 9 ? 15 - i : 15 - i - 1, bit);
  }
  set(13, 8, true);
  let row = 20;
  let direction = -1;
  let bitIndex = 0;
  for (let column = 20; column > 0; column -= 2) {
    if (column === 6) column -= 1;
    while (true) {
      for (let offset = 0; offset < 2; offset += 1) {
        const x = column - offset;
        if (matrix[row][x] !== null) continue;
        const byte = words[Math.floor(bitIndex / 8)] || 0;
        let bit = Boolean((byte >>> (7 - bitIndex % 8)) & 1);
        if ((row + x) % 2 === 0) bit = !bit;
        set(row, x, bit);
        bitIndex += 1;
      }
      row += direction;
      if (row < 0 || row >= 21) {
        row -= direction;
        direction = -direction;
        break;
      }
    }
  }
  return matrix;
}


  const renderMemberQr = (value) => {
    const target = $('[data-hp-member-qr]');
    try {
      const matrix = numericQr(String(value || ''));
      let path = '';
      matrix.forEach((row,y) => row.forEach((dark,x) => {if(dark) path += `M${x+4},${y+4}h1v1h-1z`;}));
      target.innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 29 29" aria-hidden="true"><path fill="#fff" d="M0 0h29v29H0z"/><path fill="#111" d="${path}"/></svg>`;
    } catch {
      target.textContent = t('qr_unavailable');
    }
  };
  const loadOrders = async (token) => {
    try {
      const data = await request('/hype-auth-orders', {headers:{Authorization:`Bearer ${token}`}});
      if (localStorage.getItem(storageKey) !== token) return;
      const orders = Array.isArray(data.orders) ? data.orders : [];
      $('[data-hp-orders]').innerHTML = orders.length ? orders.map(order => `<div class="hp-member-order"><div><strong>${escapeHtml(order.name || '')}</strong><span>${escapeHtml(date(order.created_at))}</span></div><strong>${escapeHtml(new Intl.NumberFormat(locale,{style:'currency',currency:order.currency || 'MYR'}).format(Number(order.total_amount || 0)))}</strong></div>`).join('') : `<p class="hp-help">${escapeHtml(t('no_orders'))}</p>`;
    } catch {
      if (localStorage.getItem(storageKey) === token) $('[data-hp-orders]').textContent = t('orders_failed');
    }
  };

  const loadAccount = async (token) => {
    login.hidden = true;
    app.hidden = true;
    loading.hidden = false;
    showError('');
    try {
      const data = await request('/hype-pass-account', { headers: { Authorization: `Bearer ${token}` } });
      if (localStorage.getItem(storageKey) !== token) return;
      renderAccount(data);
      renderMemberQr(data.profile?.shopify_customer_id);
      loadOrders(token);
      await loadVouchers(token);
      if (localStorage.getItem(storageKey) !== token) return;
      loading.hidden = true;
      app.hidden = false;
      live.textContent = t('pass_loaded');
    } catch (error) {
      if (localStorage.getItem(storageKey) !== token) return;
      localStorage.removeItem(storageKey);
      loading.hidden = true;
      login.hidden = false;
      if (error.status !== 401) showError(t('account_load_failed'));
    }
  };

  const switchTab = (tabName) => {
    $$('[data-hp-tab]').forEach((button) => {
      const active = button.dataset.hpTab === tabName;
      button.classList.toggle('is-active', active);
      button.setAttribute('aria-selected', active ? 'true' : 'false');
    });
    $$('[data-hp-panel]').forEach((panel) => {
      const active = panel.dataset.hpPanel === tabName;
      panel.classList.toggle('is-active', active);
      panel.hidden = !active;
    });
    root.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  $('[data-hp-register]').addEventListener('click', registerMember);
  $('[data-hp-request]').addEventListener('click', sendOtp);
  $('[data-hp-verify]').addEventListener('click', verifyOtp);
  $('[data-hp-otp]').addEventListener('input', (event) => {
    event.target.value = event.target.value.replace(/\D/g, '').slice(0, 6);
  });
  $('[data-hp-otp]').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') verifyOtp();
  });
  $('[data-hp-phone]').addEventListener('keydown', (event) => {
    if (event.key === 'Enter') sendOtp();
  });
  $('[data-hp-back]').addEventListener('click', () => {
    otpStep.hidden = true;
    phoneStep.hidden = false;
    showError('');
  });
  $('[data-hp-resend]').addEventListener('click', sendOtp);
  $$('[data-hp-tab]').forEach((button) => button.addEventListener('click', () => switchTab(button.dataset.hpTab)));
  $$('[data-hp-open-transactions]').forEach((button) => button.addEventListener('click', () => switchTab('transactions')));
  $$('[data-hp-open-vouchers]').forEach((button) => button.addEventListener('click', () => switchTab('vouchers')));
  $$('[data-hp-open-profile]').forEach((button) => button.addEventListener('click', () => switchTab('profile')));
  $('[data-hp-vouchers]').addEventListener('click', (event) => {
    const button = event.target.closest('[data-hp-activate-voucher]');
    if (button) activateVoucher(button);
  });
  $$('[data-hp-filter]').forEach((button) => button.addEventListener('click', () => {
    $$('[data-hp-filter]').forEach((item) => item.classList.toggle('is-active', item === button));
    const filter = button.dataset.hpFilter;
    const rows = filter === 'all' ? allTransactions : allTransactions.filter((row) => {
      const used = row.type === 'debit' || Number(row.signed_points) < 0;
      return filter === 'used' ? used : !used;
    });
    renderTransactions(rows, $('[data-hp-transactions]'), t(`${filter}_empty`));
  }));
  $('[data-hp-logout]').addEventListener('click', async () => {
    const token = localStorage.getItem(storageKey);
    localStorage.removeItem(storageKey);
    if (token) request('/hype-auth-logout', { headers: { Authorization: `Bearer ${token}` } }).catch(() => {});
    app.hidden = true;
    allVouchers = [];
    $('[data-hp-vouchers]').innerHTML = '';
    otpStep.hidden = true;
    registerStep.hidden = true;
    phoneStep.hidden = false;
    challengeId = '';
    verifiedPhone = '';
    $('[data-hp-otp]').value = '';
    $('[data-hp-register-name]').value = '';
    $('[data-hp-register-email]').value = '';
    login.hidden = false;
    switchTab('overview');
  });


    const existingToken = localStorage.getItem(storageKey);
    if (existingToken) loadAccount(existingToken);
    else {
      loading.hidden = true;
      login.hidden = false;
    }
    checkHealth();
  };

  document.querySelectorAll('[data-hp-root]').forEach(init);
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.matches('[data-hp-root]') ? event.target : event.target.querySelector('[data-hp-root]');
    if (root) init(root);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
